<input type="checkbox" [checked]="Dados" disabled="disabled" />